
















import { Component, Vue } from "vue-property-decorator";
import { AffiliateClientsParam } from "@/data/filters/client";
import { AdminRoutes } from "@/data/enums/router";

@Component({
  methods: { AffiliateClientsParam },
  components: {
    "client-search": () =>
      import("@/components/app/global/client/clientSearch.vue")
  }
})
export default class RecentAffiliatesList extends Vue {
  // Data

  public adminClientAffiliatePath =
    AdminRoutes.CLIENT_ACCOUNTS_AFFILIATE_ACCOUNT_OVERVIEW;
}
